import React from "react";

// Components
import Cookies from 'universal-cookie';
import getCorso from "../../services/getCorso";
import getValutazioniCorso from "../../services/getValutazioniCorso";
import getEsami from "../../services/getEsami";
import getStudenti from "../../services/getStudenti";
import moment from 'moment';
import { PDFViewer, Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import translateString from "../../utils/Locales";
import getMaterie from '../../services/getMaterie';

let t = translateString;

export default class PdfEsameSingoloPage extends React.Component {

  constructor(props){
    super (props)
    this.state = {
      exams: [], 
      isLoading: true,
      isReadyToShow: false
    };
  }

  async componentDidMount(){

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const currentCorso = cookies.get('currentCourse', { path: '/' });
    const studentID = cookies.get('requestedStudent', { path: '/' });
    const mediaEsami = cookies.get('studentAvg', { path: '/' });

    this.logoUrl = window.sessionStorage.getItem('logo');

    this.corso = await getCorso(username, token, currentCorso);
    this.valutazioni = await getValutazioniCorso(username, token, this.corso.id);
    this.esami = await getEsami(username, token, this.corso.id);
    this.studenti = await getStudenti(username, token);
    this.studenti = this.studenti.filter(s => s.id == studentID);
    this.materie = await getMaterie(username, token);
    this.media = mediaEsami;
    this.studenteRitirato = '';

    if (this.studenti[0].corsi_ritiro.includes(currentCorso+';')) {
      this.studenteRitirato = t('studente_ritirato');
    }

    var mainExams = [];
    var examsDetails = [];
    var ind = 0;
    const esamiStudente = this.valutazioni.filter((esame) => esame.id_studente == studentID && esame.valutazione != -1 );

    this.esami.forEach((esameCorso) => {
        esamiStudente.forEach((esameStudente) => {
            if(esameCorso.id == esameStudente.id_esame) {
              // Add this exam to the list in state
              var nota = [];
              nota.push(this.materie.find(m => m.id === esameCorso.id_materia).materia + ' ' + esameCorso.nome.toUpperCase() + ': ' + esameCorso.data);
              nota.push(esameStudente.valutazione);
              examsDetails.push(nota);
              if (examsDetails.length == 6 || ind == this.esami.length - 1) {
                mainExams.push(examsDetails);
                examsDetails = [];
              }
            }
        });
        ind++;
    });

    this.setState({ isLoading: false, exams: examsDetails, isReadyToShow: true, main: mainExams, totalPages: mainExams.length });
  }

  render () {

    const timeNow = moment().format('yyyy-MM-DD HH:mm:ss'); 
    if (this.state.isLoading) return <div />

    return (
        <div style={{width: '100%', height: '100%'}} key={Math.random()} > 
        { this.state.isReadyToShow && (
            <PDFViewer style={{width: '100%', height: '100%'}}>
                <Document>
                    { this.state.main.map((gruppo, index) => {
                        if (index == 0) {

                          return (
                            <Page size="A4" style={{ paddingTop: 80, paddingBottom: 50 }} orientation="portrait" wrap>
                                <View style={{ marginTop: -60 }}>
                                <Image style={{position: 'absolute', top: 30, left: 40, width: 'auto', height: 80}} src={ this.logoUrl ? this.logoUrl : require('../../images/icon.png') } />
                                <Text style={{position: 'absolute', top: 45, right: 30, fontSize: 12, width: '100%', textAlign: 'right', color: '#999999'}}>{timeNow}</Text>
                                <Text style={{margin: 10, fontSize: 20, width: '100%', textAlign: 'center', marginTop: '100px', paddingHorizontal: 40}}>{this.corso.name}</Text>
                                <Text style={{fontSize: 20, marginLeft: 10, marginRight: 10, width: '100%', textAlign: 'center', marginTop: '5px', color: '#999999'}}>{this.studenti[0].cognome.replace(/\\/g, '')} {this.studenti[0].nome.replace(/\\/g, '')}</Text>
                                { this.studenteRitirato != '' && <Text style={{fontSize: 16, marginLeft: 10, marginRight: 10, width: '100%', textAlign: 'center', marginTop: '10px', color: '#B62C2C'}}>{this.studenteRitirato}</Text>}
                                    <View style={styles.page} >
                                        <View style={styles.row}>
                                              <View style={{...styles.columnLeft, textAlign: 'center', fontWeight: 'bold'}}><Text style={{ fontWeight: 'bold' }}>{t('prova')}</Text></View>
                                              <View style={{...styles.columnRight, textAlign: 'center', fontWeight: 'bold'}}><Text style={{ fontWeight: 'bold' }}>{t('valutazione').toUpperCase()}</Text></View>
                                        </View>
                                        { gruppo.map((esame) => {
                                            return(
                                              <View style={{...styles.row, marginTop: -1}}>
                                                  <View style={styles.columnLeft}><Text style={{alignItems: 'center', flex:1}}>{esame[0]}</Text></View>
                                                  <View style={styles.columnRight}><Text style={{alignItems: 'center', flex:1, fontWeight: 'bold'}}>{esame[1]}</Text></View>
                                              </View>
                                            );
                                        })}
                                        { this.state.main.length == 1 && <Text style={{alignSelf: 'flex-end', marginRight: '5%', marginTop: '15px', fontWeight: 'bold', fontSize: 14}}>{t('media_complessiva')}: {this.media}</Text> }
                                    </View>
                                </View>
                                <View style={{ position: 'absolute', bottom: 50, left: 0, width: '100%', backgroundColor: '#FFFFFF', textAlign: 'right' }}><Text style={{fontWeight: 'light', fontSize: 9, color: '#BDBDBD', marginRight: 50}}>{t('pagina')} {index + 1} {t('di')} {this.state.totalPages}</Text></View>
                            </Page>
                          );
                        } else {

                          return (
                            <Page size="A4" style={{ paddingTop: 80, paddingBottom: 50 }} orientation="portrait" wrap>
                                <View style={{ marginTop: -60 }}>
                                    <View style={styles.page} >
                                        <View style={styles.row}>
                                              <View style={{...styles.columnLeft, textAlign: 'center', fontWeight: 'bold'}}><Text style={{ fontWeight: 'bold' }}>{t('esame')}</Text></View>
                                              <View style={{...styles.columnRight, textAlign: 'center', fontWeight: 'bold'}}><Text style={{ fontWeight: 'bold' }}>{t('valutazione').toUpperCase()}</Text></View>
                                        </View>
                                        { gruppo.map((esame) => {
                                            return(
                                              <View style={{...styles.row, marginTop: -1}}>
                                                  <View style={styles.columnLeft}><Text style={{alignItems: 'center', flex:1}}>{esame[0]}</Text></View>
                                                  <View style={styles.columnRight}><Text style={{alignItems: 'center', flex:1, fontWeight: 'bold'}}>{esame[1]}</Text></View>
                                              </View>
                                            );
                                        })}
                                        { (index == this.state.length - 1) &&  <Text style={{alignSelf: 'flex-end', marginRight: '5%', marginTop: '15px', fontWeight: 'bold', fontSize: 14}}>{t('media_complessiva')}: {this.media}</Text> }
                                    </View>
                                </View>
                                <View style={{ position: 'absolute', bottom: 50, left: 0, width: '100%', backgroundColor: '#FFFFFF', textAlign: 'right' }}><Text style={{fontWeight: 'light', fontSize: 9, color: '#BDBDBD', marginRight: 50}}>Pagina {index + 1} di {this.state.totalPages}</Text></View>
                            </Page>
                          );
                        }

                    })}
                    { this.state.main.length == 0 && (
                      <Page size="A4" style={{ paddingTop: 80, paddingBottom: 50 }} orientation="portrait" wrap>
                          <View style={{ marginTop: -60 }}>
                          <Image style={{position: 'absolute', top: 30, left: 30, width: '20%', height: 'auto'}} src={ this.logoUrl ? this.logoUrl : require('../../images/icon.png') } />
                          <Text style={{position: 'absolute', top: 45, right: 30, fontSize: 12, width: '100%', textAlign: 'right', color: '#999999'}}>{timeNow}</Text>
                          <Text style={{margin: 10, fontSize: 20, width: '100%', textAlign: 'center', marginTop: '100px', paddingHorizontal: 40}}>{this.corso.name}</Text>
                          <Text style={{fontSize: 20, marginLeft: 10, marginRight: 10, width: '100%', textAlign: 'center', marginTop: '5px', color: '#999999'}}>{this.studenti[0].cognome} {this.studenti[0].nome}</Text>
                          { this.studenteRitirato != '' && <Text style={{fontSize: 16, width: '100%', textAlign: 'center', marginTop: '5px', color: 'red'}}>{this.studenteRitirato}</Text>}
                              <View style={{ ...styles.page, textAlign: 'center', width: '100%', marginTop: 40 }}>
                                  <Text style={{ minWidth: '80%', maxWidth: '80%', marginLeft: '10%', fontStyle: 'italic', color: '#999999', fontSize: 14 }}>{t('no_esami')}</Text>
                              </View>
                          </View>
                          <View style={{ position: 'absolute', bottom: 50, left: 0, width: '100%', backgroundColor: '#FFFFFF', textAlign: 'right' }}><Text style={{fontWeight: 'light', fontSize: 9, color: '#BDBDBD', marginRight: 50}}>{t('pagina')} 1 {t('di')} 1</Text></View>
                      </Page>
                    )}
                </Document>
            </PDFViewer> 
        )}
        </div>
    );
  }
}

const styles = StyleSheet.create({
  
  row: {
    flexDirection: 'row',
    display: 'flex',
    border:'1 solid #000',
    width: '90%',
    marginLeft: '5%', 
    minHeight: '30px'
  },

  page: {
    fontSize: 10,
    backgroundColor: '#ffffff',
    padding: 10, 
    marginTop: '20px'
  },

  columnLeft: {
    flexDirection: 'column',
    width: '50%',
    borderRight: '1 solid #000', 
    textAlign: 'left', 
    paddingHorizontal: 30, 
    paddingVertical: 10, 
    flex: 1
  }, 

  columnRight: {
    flexDirection: 'column',
    textAlign: 'center', 
    paddingHorizontal: 30, 
    paddingVertical: 10, 
    flex: 1
  }

});